import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios PJ). */
export type RequerimentoRenovacaoPjJob = ReportJob;
export type RequerimentoRenovacaoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Requerimento de Renovação PJ. */
@Injectable({ providedIn: 'root' })
export class RequerimentoRenovacaoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'requerimento-renovacao-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.requerimentoRenovacaoPj;
}
